<template>
    <div class="filter">
        <SearchField
            v-model="searchId"
            :title="GetFilterByIdTitle()"
            type="number"
        />
        <SearchField
            v-model="searchName"
            :title="GetFilterByNameTitle()"
            type="text"
        />

        <Button
            class="filter__btn-search"
            :value="GetSearchTitle()"
            @click="clickHandler"
        />
    </div>
</template>

<script>
import SearchField from "./searchField.vue";
import Button from "./button.vue";

const EntitiesFilter = {
    components: { SearchField, Button },
    props: {
        langPack: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            currentValue: '',
            searchId: null,
            searchName: null,
        }
    },
    methods: {
        clickHandler() {
            this.$emit('search', { id: this.searchId, name: this.searchName })
        },
        GetFilterByIdTitle() {
            return this.langPack["COMPONENT_JS_FILTER_ID"] || "Entity ID";
        },
        GetFilterByNameTitle() {
            return this.langPack["COMPONENT_JS_FILTER_TITLE"] || "Title";
        },
        GetSearchTitle() {
            return this.langPack["COMPONENT_JS_SEARCH"] || "Search";
        },
    }
}

export default EntitiesFilter;
</script>

<style scoped >

.filter {
    display: grid;
}

.filter__btn-search {
    margin-left: auto;
}

</style>

